import Utils from "@/plugins/SPCUtils";

const slide_timeout = 10000;
const animate = true;

const slides = [];

const register = (data) => {
	if (data.index == 0) { data.x = 0; }

	slides.push(data);

	data.dot.onclick = () => {
		activate(data);
	}
}

const findDot = (dots, id) => {
	const links = dots.item(0).querySelectorAll('.dot');
	for (var i = 0; i < links.length; i++) {
		const _id = links.item(i).getAttribute('for');

		if (_id == id) {
			return links.item(i);
		}
	}

	return null;
}

const init = (container) => {

	// Find dots
	const dots = container.getElementsByClassName('dots');

	// Find slides
	const slides = container.getElementsByClassName('slides');

	if (slides.length < 1) return;

	const first_slides_container = slides[0];

	const _slides = first_slides_container.getElementsByClassName('slide');
	for (var i = 0; i < _slides.length; i++) {
		const slide = _slides[i];
		const id = slide.getAttribute('id');
		const dot = findDot(dots, id);

		if (dot) {
			register({ container: first_slides_container, index: i, id: id, dot: dot, slide: slide, active: false });
		} else {
			console.error('Missing id', id);
		}
	}
}

const update_dots = (container, index) => {
	slides.filter(f => f.container == container).forEach(slide => {
		if (slide.index != index) {
			slide.active = false;
			slide.dot.classList.remove('active');
		} else {
			slide.active = true;
			slide.dot.classList.add('active');
		}
	});
}

const activate = (data) => {
	
	if (data) {
		update_dots(data.container, data.index);

		const rect = data.container.getBoundingClientRect();

		const x = data.index * rect.width;
		const y = 0;

		data.container.scroll({
			top: y,
			left: x,
			behavior: 'smooth'
		});
	// } else {
		// console.error('Data error');
	}
}

const disableAll = (data) => {
	if (!data) {
		slides.forEach(e => {
			e.slide.classList.remove('active');
			e.dot.classList.remove('active');
		});
	} else {
		hideAll(data);
	}
}

const hideAll = (data) => {
	slides
		.filter(f => f.container == data.container)
		.forEach(e => {
			e.slide.classList.remove('active');
			e.dot.classList.remove('active');
		});
}

const start = () => {
	disableAll();
	const containers = slides.map(f => f.container.id).filter(Utils.distinct);

	containers.forEach(container => {
		slides.filter(f => (f.container.id == container) && (f.index == 0)).forEach(f => activate(f));
	});

	if (animate) {
		containers.forEach(container => {
			const _interval = slide_timeout + Math.floor(Math.random() * (slide_timeout / 2));
			setInterval(() => { activate(find_next(container)); }, _interval);
		});
	}
}

const find_next = (container) => {
	var result = null;

	const _slides = slides.filter(f => f.container.id == container);
	const current_index = parseInt(_slides.filter(f => f.active).map(m => m.index));
	const next_value = (current_index + 1) > (_slides.length - 1) ? 0 : current_index + 1;

	_slides.filter(slide => slide.index == next_value).forEach(slide => result = slide);

	return result;
}

const install = (vue) => {
	vue.directive('slider-container', {
		bind(el) {
			init(el);
		}
	});

	vue.prototype.$slider = {
		start
	}
};

export default install;